module.exports = __webpack_public_path__ + "img/twitter.320b8775.svg";